const hd550 = () => {
   return (
      <p>
         Видеоэндоскопическая система SonoScape HD-550 класса FULL HD применяется для обследования и эффективного лечения пациентов. Использование такого оборудования помогает получить изображение с камеры, введенной в организм пациента. Картинка четкая и понятная, может быть записана на носитель для дальнейшего использования.
         <br /><br />                       
         <strong>Видеопроцессор HD-550</strong>
         <br /><br />
         • Автоматический баланс белого<br />
         • Подчеркивание границ изображения (увеличивает резкость изображения, делает его более детализированным)<br />
         • Автоматическая и ручная настройки яркости, цветности изображения<br />
         • Цифровое увеличение изображения<br />
         • Режим улучшения визуализации сосудов CHb - инновационный и перспективный режим, основанный на принципе усиления длины волны, отражаемой клетками крови, визуализация красных кровянных телец (эритроциты). Незаменим при диагностике воспалительных заболеваний и атрофических изменениях слизистой оболочки.<br />
         • Режим NBI виртуальной хромоэндоскопии (WL/EWL / VIST/SFI - четырехэтапная технология). Экспертный режим визуализации сосудов и структур поверхности слизистой. Сочетает технологию оптического и электронного улучшения изображения, получаемого при узкополосном освещении. Помогает выявлять онкологические новообразования на ранних стадиях с высоким уровнем достоверности.<br />
         • Режим стоп-кадра
         <br /><br />
         <strong>Интегрированная цифровая рабочая станция:</strong>
         <br /><br />
         •	Централизованная система (отсутствие необходимости в дополнительном компьютере)<br />
         •	Встроенный жесткий диск не менее 500 ГБ<br />
         •	USB порты для подключения внешних накопителей и принтеров не менее 5 (пяти)<br />
         •	Сохранение информации не менее 10000 пациентов<br />
         •	Клавиатура для ввода данных, обработки полученной информации<br />
         •	Подготовка и распечатка результатов исследований на месте<br />
         •	Ввод и сохранение данных о пациентах<br />
         •	Сохранение изображений/видео с выводом на экран под основным изображением в режиме предпросмотра<br />
         •	Программирование кнопок на рукоятке эндоскопа<br />
         •	Сохранение до 10 комбинаций настроек исследования для использования в различных областях и условиях различными специалистами
         <br /><br />
         <strong>Источник света VLS-55Q</strong>
         <br /><br />
         • Два специальных режима освещения<br />
         • 2 LED лампы<br />
         • Индикатор отработанного времени на лицевой панели осветителя<br />
         • Уровень интенсивности света 1 - 19<br />
         • Непрерывный срок службы лампы составляет не менее 10 000 часов <br />
         <br /><br />
         <strong>Монитор 26” (Full HD)</strong>
         <br /><br />
         • Медицинский монитор высокой чёткости, адаптирован специально для системы HD-550 (Full HD)                       
         <br /><br />                        
         <strong>Возможные для подключения видеоэндоскопы:</strong>
         <br /><br />                        
         • Видеогастроскоп EG-550<br />
         • Видеоколоноскоп EC-550T<br />
         • Видеогастроскоп EG-500<br />
         • Видеоколоноскоп EC-500T<br />
         • Видеобронхоскоп EB-500
         <br /><br />                        
         <strong>Дополнительные принадлежности для HD-550 Full HD</strong><br /><br /> 
         Ножной переключатель для управления функцией стоп-кадра                                              
      </p>
   );
}

export default hd550;